var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49189 0.327327C2.12039 -0.0813304 1.48794 -0.111447 1.07928 0.26006C0.670623 0.631567 0.640506 1.26402 1.01201 1.67267L2.49189 0.327327ZM6.75195 6.5L7.49189 7.17267L8.10341 6.5L7.49189 5.82733L6.75195 6.5ZM1.01201 11.3273C0.640506 11.736 0.670623 12.3684 1.07928 12.7399C1.48794 13.1114 2.12039 13.0813 2.49189 12.6727L1.01201 11.3273ZM1.01201 1.67267L6.01201 7.17267L7.49189 5.82733L2.49189 0.327327L1.01201 1.67267ZM6.01201 5.82733L1.01201 11.3273L2.49189 12.6727L7.49189 7.17267L6.01201 5.82733Z",
    fill: "#FF7B72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfo);
export default __webpack_public_path__ + "static/media/MoreInfo.fe5c8b6e2bfb34dcc5cefcdfa0e58ff5.svg";
export { ForwardRef as ReactComponent };